/**
 * Decimals the Excel export shows per column, matching the grid's display: `gridTable` writes raw
 * numbers, so the number format has to be declared again.
 */
export const CONSUMPTION_FRACTION_DIGITS: Record<string, number> = {
  fuelRatePer100Km: 2,
  electricRatePer100Km: 2,
  fuelUsedLiters: 2,
  electricUsedKWh: 2,
  filledLiters: 2,
  fuelDeviationLiters: 2,
  chargedKWh: 2,
  chargeDurationHours: 2,
  distanceKm: 0,
  measuredDistanceKm: 0,
};

export const CHARGE_EVENT_FRACTION_DIGITS: Record<string, number> = {
  durationHours: 2,
  energyConsumedKwh: 2,
  startStateOfCharge: 0,
  endStateOfCharge: 0,
  distanceSinceLastChargeKm: 0,
  odometerKm: 0,
};

export const FUEL_UP_EVENT_FRACTION_DIGITS: Record<string, number> = {
  volumeLiters: 2,
  cardVolumeLiters: 2,
  totalFuelUsedLiters: 2,
  deviationFactor: 2,
  odometerKm: 0,
};
